document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('subToggle');
    const subBadges = document.querySelector('.subscription-badges');
    const oneTimeBadges = document.querySelector('.one-time-badges');

    function updateBadges(state) {
        if (!subBadges || !oneTimeBadges) return;
        if (state === 'subscribe') {
            subBadges.style.display = 'flex';
            oneTimeBadges.style.display = 'none';
        } else {
            subBadges.style.display = 'none';
            oneTimeBadges.style.display = 'flex';
        }
    }

    function applyRechargeClick(state) {
        const subLabel = document.querySelector('label[data-option-subsave]');
        const oneTimeLabel = document.querySelector('label[data-option-onetime]');
        const originalPrice = document.querySelector('.product-price .original-price');
        
        if (!subLabel || !oneTimeLabel) return;

        if (state === 'subscribe') {
            subLabel.click();
            if (originalPrice) {
                originalPrice.style.display = '';
            }
        } else {
            if (originalPrice) {
                originalPrice.style.display = 'none';
            }
            oneTimeLabel.click();
        }
    }

    // Function to get current active price from Recharge
    function getCurrentRechargePrice() {
        // Check if subscription is active
        const isSubscriptionActive = toggle && toggle.checked;
        
        if (isSubscriptionActive) {
            // For subscription: look for the recharge-inner-most-price or active subscription price
            const subscriptionPrice = document.querySelector('.price.recharge-inner-most-price') ||
                                    document.querySelector('.rc_widget__price--subsave') ||
                                    document.querySelector('.rc-option__price.rc_widget__price:not(.rc_widget__price--onetime)');
            return subscriptionPrice;
        } else {
            // For one-time: look for one-time price
            const oneTimePrice = document.querySelector('.rc_widget__price--onetime') ||
                               document.querySelector('.rc-option__price.rc_widget__price.rc_widget__price--onetime');
            return oneTimePrice;
        }
    }

    // Function to get original/compare price
    function getOriginalPrice() {
        // Look for original price in various locations
        const originalPrice = document.querySelector('.rc_widget__compare-price') ||
                           document.querySelector('.rc-compare-price') ||
                           document.querySelector('[data-recharge-compare-price]') ||
                           document.querySelector('.product-price .original-price');
        return originalPrice;
    }

    // Function to calculate and update discount percentage
    function updateDiscountPercentage() {
        // Use the correct selectors based on your debug output
        const subscriptionPriceEl = document.querySelector('.rc_widget__price--subsave') ||
                                   document.querySelector('.price.recharge-inner-most-price');
        const oneTimePriceEl = document.querySelector('.rc_widget__price--onetime');
        
        // Try multiple selectors for the title element
        const titleElement = document.querySelector('.subscription-state .title:not(.title--large)') ||
                           document.querySelector('.subscription-state .title') ||
                           document.querySelector('.subscription-text .title:not(.title--large)');
        
        console.log('=== DISCOUNT UPDATE DEBUG ===');
        console.log('Title element found:', titleElement);
        console.log('Title element classes:', titleElement?.className);
        console.log('Title element text:', titleElement?.textContent);
        console.log('Subscription price element:', subscriptionPriceEl);
        console.log('One-time price element:', oneTimePriceEl);
        
        if (subscriptionPriceEl && oneTimePriceEl && titleElement) {
            // Extract numeric values from price strings
            const subscriptionPrice = parseFloat(subscriptionPriceEl.textContent.replace(/[^0-9.]/g, ''));
            const oneTimePrice = parseFloat(oneTimePriceEl.textContent.replace(/[^0-9.]/g, ''));
            
            console.log('Parsed subscription price:', subscriptionPrice);
            console.log('Parsed one-time price:', oneTimePrice);
            
            if (subscriptionPrice && oneTimePrice && oneTimePrice > subscriptionPrice) {
                // Calculate discount percentage
                const discount = Math.round(((oneTimePrice - subscriptionPrice) / oneTimePrice) * 100);
                
                // Check if title doesn't have the special classes that should remain static
                const hasLargeClass = titleElement.classList.contains('title--large');
                const wrapperHasHiddenSubscription = document.querySelector('.product-subscription-type .hidden-suscription');
                
                console.log('Has large class:', hasLargeClass);
                console.log('Wrapper has hidden subscription:', !!wrapperHasHiddenSubscription);
                console.log('Calculated discount:', discount);
                
                if (!hasLargeClass && !wrapperHasHiddenSubscription) {
                    // Update the title
                    const newTitle = `Subscribe and Save ${discount}%`;
                    titleElement.textContent = newTitle;
                    console.log(`✅ Updated title to: "${newTitle}"`);
                } else {
                    console.log('❌ Title has special class or hidden subscription active, not updating');
                }
            } else {
                console.log('❌ Invalid price calculation or one-time not greater than subscription');
                console.log('Subscription >= OneTime or invalid prices');
            }
        } else {
            console.log('❌ Missing elements for discount calculation');
            console.log('Subscription price element exists:', !!subscriptionPriceEl);
            console.log('One-time price element exists:', !!oneTimePriceEl);
            console.log('Title element exists:', !!titleElement);
            
            // Fallback: try to get discount from data attribute
            const wrapper = document.querySelector('[data-subscription-discount]');
            if (wrapper && titleElement) {
                const defaultDiscount = wrapper.dataset.subscriptionDiscount;
                const hasLargeClass = titleElement.classList.contains('title--large');
                const wrapperHasHiddenSubscription = document.querySelector('.product-subscription-type .hidden-suscription');
                
                console.log('Using fallback discount:', defaultDiscount);
                
                if (!hasLargeClass && !wrapperHasHiddenSubscription && defaultDiscount) {
                    const newTitle = `Subscribe and Save ${defaultDiscount}%`;
                    titleElement.textContent = newTitle;
                    console.log(`✅ Updated title with fallback discount: "${newTitle}"`);
                }
            }
        }
    }

    // Updated price update function targeting the correct Recharge elements
    function updateCustomPrices() {
        console.log('=== UPDATING CUSTOM PRICES ===');
        
        // Get custom price elements
        const customPriceElements = document.querySelectorAll('[data-recharge-add-to-cart-price]');
        const customOriginalElements = document.querySelectorAll('[data-recharge-add-to-cart-original-price]');

        // Get current prices from Recharge
        const currentPrice = getCurrentRechargePrice();
        const originalPrice = getOriginalPrice();

        console.log('Current price element found:', currentPrice);
        console.log('Original price element found:', originalPrice);

        // Update current price
        if (currentPrice && customPriceElements.length > 0) {
            const priceText = currentPrice.textContent.trim();
            console.log('Updating custom price to:', priceText);
            customPriceElements.forEach(element => {
                element.textContent = priceText;
            });
        }

        // Update original price
        if (originalPrice && customOriginalElements.length > 0) {
            const originalPriceText = originalPrice.textContent.trim();
            console.log('Updating custom original price to:', originalPriceText);
            customOriginalElements.forEach(element => {
                element.textContent = originalPriceText;
            });
        }

        // Update discount percentage in title
        updateDiscountPercentage();

        // Alternative approach: If no prices found, try to get from variant data
        if (!currentPrice) {
            console.log('No Recharge price found, checking alternative sources...');
            
            // Check if we can get price from selected selling plan
            const selectedPlan = document.querySelector('input[name*="selling_plan"]:checked');
            if (selectedPlan) {
                console.log('Selected selling plan:', selectedPlan.value);
                
                // Try to find price in the label
                const planLabel = document.querySelector(`label[for="${selectedPlan.id}"]`);
                if (planLabel) {
                    const priceMatch = planLabel.textContent.match(/\$[\d,]+\.?\d*/);
                    if (priceMatch && customPriceElements.length > 0) {
                        console.log('Found price in label:', priceMatch[0]);
                        customPriceElements.forEach(element => {
                            element.textContent = priceMatch[0];
                        });
                    }
                }
            }
        }
    }

    // Observer specifically for the recharge price elements we identified
    function observeRechargePrice() {
        console.log('Setting up specific price observers...');
        
        // Watch for changes in the specific price elements we found
        const priceSelectors = [
            '.price.recharge-inner-most-price',
            '.rc-option__price.rc_widget__price',
            '.rc_widget__price--subsave',
            '.rc_widget__price--onetime'
        ];

        const setupObserver = () => {
            priceSelectors.forEach(selector => {
                const elements = document.querySelectorAll(selector);
                elements.forEach(element => {
                    const observer = new MutationObserver(function(mutations) {
                        console.log('Price change detected in:', selector);
                        setTimeout(updateCustomPrices, 50);
                    });

                    observer.observe(element, {
                        childList: true,
                        characterData: true,
                        subtree: true
                    });
                });
            });
        };

        // Setup immediately and also after a delay for dynamic content
        setupObserver();
        setTimeout(setupObserver, 1000);
        setTimeout(setupObserver, 2000);
    }

    // Force subscribe option if toggle is checked
    function forceSubscribeIfToggleChecked() {
        if (toggle && toggle.checked) {
            const subLabel = document.querySelector('label[data-option-subsave]');
            if (subLabel && !subLabel.classList.contains('rc_widget__option--active')) {
                subLabel.click();
                updateBadges('subscribe');
                setTimeout(updateCustomPrices, 300);
            }
        }
    }

    // Observe when Recharge mounts the radios
    function observeRechargeRadios() {
        const radiosContainer = document.querySelector('.rc-radio-group__options');
        if (!radiosContainer) {
            setTimeout(observeRechargeRadios, 150);
            return;
        }
        
        const radiosObserver = new MutationObserver(() => {
            forceSubscribeIfToggleChecked();
        });
        radiosObserver.observe(radiosContainer, { childList: true, subtree: true });
        forceSubscribeIfToggleChecked();
    }

    if (toggle) {
        // When user manually changes the toggle
        toggle.addEventListener('change', function () {
            const state = this.checked ? 'subscribe' : 'onetime';
            console.log('Toggle changed to:', state);
            applyRechargeClick(state);
            updateBadges(state);
            setTimeout(updateCustomPrices, 300);
        });

        // Start observing Recharge widget
        observeRechargeRadios();
    }

    // Sync custom dropdown with Recharge dropdown
    const customDropdown = document.querySelector('.subscription-dropdown');
    if (customDropdown) {
        const observer = new MutationObserver(() => {
            const rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
            if (rechargeDropdown) {
                customDropdown.addEventListener('change', function () {
                    const selectedValue = this.value;
                    console.log('Custom dropdown changed to:', selectedValue);
                    const matchingOption = Array.from(rechargeDropdown.options).find((opt) => opt.value === selectedValue);
                    if (matchingOption) {
                        rechargeDropdown.value = selectedValue;
                        rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                        setTimeout(updateCustomPrices, 300);
                    }
                });
                
                const initialSelected = customDropdown.value;
                rechargeDropdown.value = initialSelected;
                rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(updateCustomPrices, 300);
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Choices.js for visual dropdown
    const dropdownEl = document.getElementById('custom-subscription-dropdown');
    if (dropdownEl) {
        const choices = new Choices(dropdownEl, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
        });

        const observer = new MutationObserver(() => {
            const rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
            if (rechargeDropdown) {
                dropdownEl.addEventListener('change', function () {
                    const selectedValue = this.value;
                    console.log('Choices.js dropdown changed to:', selectedValue);
                    const option = Array.from(rechargeDropdown.options).find((opt) => opt.value === selectedValue);
                    if (option) {
                        rechargeDropdown.value = selectedValue;
                        rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                        setTimeout(updateCustomPrices, 300);
                    }
                });
                
                rechargeDropdown.value = dropdownEl.value;
                rechargeDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(updateCustomPrices, 300);
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Start observing price changes
    observeRechargePrice();

    // Listen for Recharge-specific events
    document.addEventListener('recharge:plan-changed', updateCustomPrices);
    document.addEventListener('recharge:frequency-changed', updateCustomPrices);

    // Listen for any selling plan changes in the form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
        productForm.addEventListener('change', function(e) {
            if (e.target.name && e.target.name.includes('selling_plan')) {
                console.log('Form selling plan changed:', e.target.value);
                setTimeout(updateCustomPrices, 300);
            }
        });
    }

    // Initial price update
    setTimeout(updateCustomPrices, 1000);
    
    // Additional fallback updates
    setTimeout(updateCustomPrices, 2000);
    setTimeout(updateCustomPrices, 3000);

    // Debug: Log all title elements to help identify the correct one
    setTimeout(() => {
        console.log('=== ALL TITLE ELEMENTS DEBUG ===');
        const allTitles = document.querySelectorAll('.title, [class*="title"]');
        allTitles.forEach((title, index) => {
            console.log(`Title ${index}:`, {
                element: title,
                className: title.className,
                textContent: title.textContent,
                parent: title.parentElement?.className
            });
        });
    }, 500);
});